import { MARKETPLACE_FEATURE } from '@/config/marketplaceCapabilities.js';

export default [
  {
    title: 'Finance',
    channel: 'amazon-seller',
    icon: { icon: 'ic:outline-account-balance-wallet' },
    // No group-level envOnly: Transactions Ledger and Seller COGS have shipped, and VerticalNavGroup
    // gates the group itself — a dev-only group would hide its released child on
    // prod. The remaining children stay individually dev-only.
    feature: MARKETPLACE_FEATURE.FINANCE,
    children: [
      {
        title: 'Settlement Details',
        action: 'read',
        subject: 'User',
        to: 'finance-settlement-details',
        icon: { icon: 'ic:outline-receipt-long' },
        envOnly: 'development',
      },
      {
        title: 'Reimbursements',
        action: 'read',
        subject: 'User',
        to: 'finance-reimbursements',
        icon: { icon: 'ic:outline-payments' },
        envOnly: 'development',
      },
      {
        title: 'Monthly Storage Fees',
        action: 'read',
        subject: 'User',
        to: 'finance-storage-fees',
        icon: { icon: 'ic:outline-warehouse' },
        envOnly: 'development',
      },
      {
        title: 'Long-Term Storage Fees',
        action: 'read',
        subject: 'User',
        to: 'finance-long-term-storage',
        icon: { icon: 'ic:outline-history' },
        envOnly: 'development',
      },
      {
        title: 'Storage Overage Fees',
        action: 'read',
        subject: 'User',
        to: 'finance-storage-overage',
        icon: { icon: 'ic:outline-warning' },
        envOnly: 'development',
      },
      {
        title: 'FBA Fee Preview',
        action: 'read',
        subject: 'User',
        to: 'finance-fba-fees',
        icon: { icon: 'ic:outline-request-quote' },
        envOnly: 'development',
      },
      {
        title: 'Transactions Ledger',
        action: 'read',
        subject: 'User',
        to: 'finance-transactions',
        icon: { icon: 'ic:outline-receipt' },
      },
      {
        title: 'Seller COGS',
        action: 'read',
        subject: 'User',
        to: 'finance-cogs',
        icon: { icon: 'ic:outline-price-change' },
      },
    ],
  },
];
